export * from './customer-profile.component';
